<h1>Message Categories</h1>
<p>
  This is the global list of categories available for use by organisations.
</p>
<data-list-table [data]="categories$"
  [config]="tableConfig">
  <mat-form-field class="example-full-width"
    *dataListCellRenderer="'name'; let row;">
    <input matInput
      [formControl]="forms.get(row).controls['name']">
  </mat-form-field>
  <ca-icon-select *dataListCellRenderer="'icon'; let row;"
    [formControl]="forms.get(row).controls['icon']"></ca-icon-select>
  <ng-container *dataListCellRenderer="'actions'; let row;">
    <button (click)="saveRow(row)"
      color="primary"
      mat-flat-button>Save</button>
  </ng-container>
  <ng-container *dataListCellRenderer="'status'; let row;">
    <ca-row-result [ok]="forms.get(row).pristine"
      [messages]="{ ok: 'Saved', error: 'Changes Not Saved' }"></ca-row-result>
  </ng-container>
</data-list-table>
<button class="action"
  (click)="createCategory()"
  mat-flat-button>Create</button>